import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Mon conseiller a renégocié l'ensemble de mes contrats auto et habitation. Résultat : 640 € économisés par an, avec de meilleures garanties. Impressionnant de rigueur.",
    name: "Claire & Mathieu R.",
    role: "Famille — Lyon",
  },
  {
    quote:
      "Après un dégât des eaux, ASSU-FRANCE a pris le relais face à l'assureur. Indemnisation obtenue en trois semaines, sans que j'aie à me battre. C'est exactement ça, un courtier.",
    name: "Sophie L.",
    role: "Cheffe d'entreprise — Bordeaux",
  },
  {
    quote:
      "Un interlocuteur unique qui décroche son téléphone. Ma complémentaire santé et ma RC Pro sont enfin claires et cohérentes. Je recommande sans réserve.",
    name: "Karim B.",
    role: "Artisan — Lille",
  },
];

export default function Testimonials() {
  return (
    <section id="temoignages" data-testid="client-testimonials-section" className="relative py-24 sm:py-36 bg-slate2/30 border-y hairline">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="mb-16 sm:mb-20 max-w-3xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber/90 mb-6 flex items-center gap-3">
            <span className="inline-block h-px w-10 bg-amber/60" /> Ils nous font confiance
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-ivory text-balance">
            La confiance se mesure{" "}
            <span className="italic text-amber">aux résultats.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -6, transition: { duration: 0.3, ease: "easeOut" } }}
              className="relative rounded-3xl border hairline bg-cardbg p-8 sm:p-10 transition-[border-color] duration-500 hover:border-amber/40"
            >
              <Quote className="h-8 w-8 text-amber/40 mb-6" />
              <blockquote className="font-serif text-xl italic leading-relaxed text-ivory/85">
                «&nbsp;{t.quote}&nbsp;»
              </blockquote>
              <figcaption className="mt-8 flex items-center justify-between">
                <div>
                  <p className="font-sans text-sm font-semibold text-ivory">{t.name}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ivory/40 mt-1">{t.role}</p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-3.5 w-3.5 fill-amber text-amber" />
                  ))}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
